import * as Yup from "yup";

export const validation = Yup.object().shape({
  name: Yup.string().required("กรุณากรอก"),
  acronym: Yup.string().required("กรุณากรอก"),
  // type: Yup.string().required("กรุณากรอก"),
});
